module.exports = __webpack_public_path__ + "static/new30devices-515a003f82ff1e1979fdfbf5e7354934.png";